import { render } from "./cardCollaborator.vue?vue&type=template&id=f8b09bb4&scoped=true"
import script from "./cardCollaborator.vue?vue&type=script&lang=js"
export * from "./cardCollaborator.vue?vue&type=script&lang=js"

import "./cardCollaborator.vue?vue&type=style&index=0&id=f8b09bb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b09bb4"]])

export default __exports__